import React from 'react';

/**
 * PublicationSortSelect
 * - Controlled select for publication sorting (list page).
 * - Props:
 *   - sort: { order_by: string, order: 'asc'|'desc' }
 *   - onChange: (nextSort) => void
 *   - className: optional additional class names
 */
export default function PublicationSortSelect({ sort = { order_by: 'publish_date', order: 'desc' }, onChange, className = '' }) {
  const value = `${sort?.order_by ?? ''}:${sort?.order ?? ''}`;

  const handleChange = (e) => {
    const v = String(e.target.value || '');
    // value format: order_by:order
    const [ob, od] = v.split(':');
    const map = {
      '': { order_by: 'publish_date', order: 'desc' }, // Recently Added default
    };
    const next = map[v] || { order_by: ob || 'publish_date', order: od || 'desc' };
    if (typeof onChange === 'function') onChange(next);
  };

  return (
    <div className={`sort lg:flex items-center gap-3 text-[13px] text-[#6C7687] font-medium ${className}`}>
      <p className="hidden lg:flex items-center gap-1">
        <img src={`${rmVars.themeUrl}images/filter_list_ico.png`} className="w-4 h-4" alt="sort icon" />
        Sort by
      </p>

      <select
        className="w-full py-2 px-3 bg-white border border-[#E4E8F1] rounded-lg appearance-none bg-no-repeat bg-size-[18px] bg-position-[98%] text-[13px] text-[#6C7687] outline-none lg:w-[184px]"
        style={{ backgroundImage: `url(${rmVars.themeUrl}images/expand_more_8D9AAF.png)` }}
        value={value}
        onChange={handleChange}
      >
        <option className="bg-white" value="score:desc">Relevance</option>
        <option className="bg-white" value="publish_date:desc">Date: newest first</option>
        <option className="bg-white" value="publish_date:asc">Date: oldest first</option>
        <option className="bg-white" value="title:asc">Document Title: A to Z</option>
        <option className="bg-white" value="title:desc">Document Title: Z to A</option>
        <option className="bg-white" value="ranking:asc">Ranking: highest first</option>
        <option className="bg-white" value="ranking:desc">Ranking: lowest first</option>
        <option className="bg-white" value="citations:desc">Citations: highest first</option>
        <option className="bg-white" value="input_date:desc">Recently Added</option>
      </select>
    </div>
  );
}
